import Formatter from 'src/class/Formatter';
import i18n from 'src/i18n';
import Tables from 'src/class/Tables';

const configTable = () => {
    const Table = { ...Tables.Table };
    Table.tableColumns = [
        {
            prop: 'farm_name',
            label: i18n.t('common_words.farm'),
            minWidth: 80,
            align: 'left',
            sortable: true,
        },
        {
            prop: 'date_save',
            label: i18n.t('common_words.date'),
            minWidth: 80,
            align: 'center',
            sortable: true,
        },
        {
            prop: 'nursery_name',
            label: i18n.t('sowing.nursery'),
            minWidth: 80,
            align: 'left',
            sortable: true,
        },
        {
            prop: 'crop_variety_name',
            label: i18n.t('common_words.crop_variety'),
            minWidth: 80,
            align: 'left',
            sortable: true,
        },
        {
            prop: 'plants_seeds_recieved',
            label: i18n.t('sowing.plants_seeds_recieved'),
            minWidth: 80,
            align: 'center',
            sortable: true,
            formatter: (row) => {
                return Formatter.formatNumber(
                    row.plants_seeds_recieved
                );
            },
        },
        {
            prop: 'plants_seeds_rejected',
            label: i18n.t('sowing.plants_seeds_rejected'),
            minWidth: 80,
            align: 'center',
            sortable: true,
            formatter: (row) => {
                return Formatter.formatNumber(
                    row.plants_seeds_rejected
                );
            },
        },
        {
            prop: 'reason_rejection_name',
            label: i18n.t('sowing.reason_rejection'),
            minWidth: 80,
            align: 'left',
            sortable: true,
        },
    ];
    const Search = { ...Tables.Search };

    return { Table, Search };
};
export default configTable;